export function getTraceId() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const randomByte = crypto.getRandomValues(new Uint8Array(1))[0];
    const r = randomByte % 16;

    if (c === 'x') {
      return r.toString(16);
    }

    return (8 + (r % 4)).toString(16);
  });
}

export const setupTracing = (): void => {
  // makes sure all internal fetch calls have X-Trace-Id
  const originalFetch = window.fetch;
  window.fetch = function (input: RequestInfo, init?: RequestInit): Promise<Response> {
    const url = typeof input === 'string' ? input : input.url;
    const isInternal = url.startsWith('/') || url.startsWith(window.location.origin);

    if (!isInternal) return originalFetch.call(this, input, init);

    const newInit = init ? { ...init } : {};
    const headers = newInit.headers || {};

    const hasTraceId = headers instanceof Headers
      ? headers.has('X-Trace-Id')
      : !!(headers as any)['X-Trace-Id'];

    if (!hasTraceId) {
      if (headers instanceof Headers) {
        headers.set('X-Trace-Id', getTraceId());
      } else {
        newInit.headers = { ...(headers as Record<string, string>), 'X-Trace-Id': getTraceId() };
      }
    }

    return originalFetch.call(this, input, newInit);
  };

  // setup jQuery global AJAX headers
  if (typeof (window as any).$ !== 'undefined' && (window as any).$.ajaxSetup) {
    (window as any).$.ajaxSetup({
      beforeSend: (xhr: any, settings: any) => {
        if (!settings.crossDomain) xhr.setRequestHeader('X-Trace-Id', getTraceId());
      },
    });
  }

  // setup Rails UJS global AJAX headers
  document.addEventListener('ajax:beforeSend', (event: any) => {
    const { xhr } = event.detail;
    if (xhr && typeof xhr.setRequestHeader === 'function') {
      xhr.setRequestHeader('X-Trace-Id', getTraceId());
    }
  });
};
